import BasicButton from "../BasicButton";
import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import { useEffect, useState } from "react";
import useScreenSize from "../../utils/getDimentions";

export const HeaderTabs = ({
  tabs,
  maxWidth,
  tabIndex,
  switchTab,
  mainColor,
}: {
  tabs: stdObject;
  maxWidth: number;
  tabIndex: number;
  switchTab: (value: number) => void;
  mainColor: string;
}) => {
  return (
    <div
      style={{
        padding: 5,
        overflowX: "auto",
        maxWidth,
      }}
    >
      <table align="center">
        <tbody>
          <tr>
            {tabs.map(
              (e: stdObject, index: number) =>
                e && (
                  <td key={index}>
                    <BasicButton
                      onClick={() => switchTab(e.code)}
                      title={e.label}
                      color={tabIndex === e.code ? mainColor : colors.darkGrey}
                      style={e.style ?? {}}
                    />
                  </td>
                ),
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
